import { ManifestStatus } from '../models';

interface StatusConfig {
  label: string;
  bg: string;
  text: string;
}

const STATUS_CONFIG: Record<ManifestStatus, StatusConfig> = {
  GENERADO: {
    label: 'Pending',
    bg: 'bg-yellow-100 dark:bg-yellow-900/30',
    text: 'text-yellow-800 dark:text-yellow-300',
  },
  COMPLETADO: {
    label: 'Completed',
    bg: 'bg-green-100 dark:bg-green-900/30',
    text: 'text-green-800 dark:text-green-300',
  },
  ANULADO: {
    label: 'Cancelled',
    bg: 'bg-red-100 dark:bg-red-900/30',
    text: 'text-red-800 dark:text-red-300',
  },
};

export const getManifestStatusConfig = (status: ManifestStatus): StatusConfig => {
  return STATUS_CONFIG[status] || STATUS_CONFIG.GENERADO;
};
